import type { SiteConfig } from '../../@types/context/site-config.types';

export const serviceVwoAxoNoConfig: Pick<SiteConfig['services'], 'vwo'> = {
  vwo: { id: '1079580' },
};
